





















import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import Student from '@/models/Students/Student'
import config from '@/config'
import {USER_ROLE_STUDAUTH, STUDENT_INFO_SHOW_PASSWORD} from '@/constants'
export default Vue.extend({
  props: {
    scope: {} as () => {student: Student},
    options: {}
  },
  components: {
    infoRowsBlock
  },
  data () {
    return {
      passVissible: false,
      authData: {}
    }
  },
  methods: {
    async getPassword () {
      return this.$store.dispatch('students/getPassword', this.scope.student.getId())
    },
    async togglePassword () {
      try {
        let authData = await this.getPassword()
        this.authData = authData;
        this.passVissible = !this.passVissible;
      } catch (error) {
        console.error('LOG: togglePassword -> error', error)
        // @ts-ignore
        this.$message.error(this.$t('labels.can_not_download_access'));
      }
    },
    async resetPassword () {
      try {
        await this.$store.dispatch('students/resetPassword', this.scope.student.getId())
        this.authData = await this.getPassword()
        // @ts-ignore
        this.$message.success(this.$t('labels.password_changed'))
        // this.passVissible = false;
      } catch (error) {
        console.error('LOG: resetPassword -> error', error)
        // @ts-ignore
        this.$message.error(this.$t('labels.can_not_reset_password'));
      }
    }
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_STUDAUTH)
      }
      return false
    },
    showPassword () {
      return config(STUDENT_INFO_SHOW_PASSWORD) !== false
    }
  }
})
